/**
 * One shared scroll → RAF on mobile so hero scroll does not run 4+ listeners
 * that each call getBoundingClientRect in the same frame.
 */

export const MOBILE_SCROLL_MQ = "(max-width: 767px)";

const listeners = new Set();
let frameId = 0;

function flushFrames() {
  frameId = 0;
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* noop */
    }
  });
}

function onScrollOrResize() {
  if (frameId) return;
  frameId = requestAnimationFrame(flushFrames);
}

export function isMobileViewport() {
  try {
    return window.matchMedia(MOBILE_SCROLL_MQ).matches;
  } catch {
    return false;
  }
}

/** Subscribe on mobile only; returns unsubscribe. */
export function subscribeMobileScrollFrame(fn) {
  if (!isMobileViewport()) return () => {};

  listeners.add(fn);
  if (listeners.size === 1) {
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize, { passive: true });
    frameId = requestAnimationFrame(flushFrames);
  }

  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
      if (frameId) cancelAnimationFrame(frameId);
      frameId = 0;
    }
  };
}
